export default [
    {
        path: 'relatorio-viagem',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-viagem' */
            '@/views/transporte-paciente/relatorio-viagem/Index'
        ),
        redirect: 'relatorio-viagem/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-viagem-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-viagem' */
                    '@/views/transporte-paciente/relatorio-viagem/List.vue'
                ),
            },
        ],
    },
]
